'use strict';

export default function isCancel(value) {
  return !!(value && value.__CANCEL__);
}



// WEBPACK FOOTER //
// ../lib/cancel/isCancel.js